import React from 'react'
import {Link} from 'react-router-dom'
import SignedInLink from './SignedInLink'
import SignedOutLink from './SignedOutLink'
import './Navbar.css';

const Navbar = () =>{
  return (
    <nav className = "nav-wrapper grey darken-3">
      <div className = "container">
        <Link to='/' className="logo">Dengue Secure</Link>
        <SignedInLink></SignedInLink>
        {/* <SignedOutLink></SignedOutLink> */}
      </div>
    </nav>
  )
}

export default Navbar